import { formatValue } from "./formatValue";

export const handleBlur = (
  event: any,
  value: string | number,
  decimals: number,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
) => {
  const formattedValue = formatValue(value, decimals);
  if (onChange) {
    const fakeEvent = {
      ...event,
      target: { ...event.target, value: formattedValue },
    };
    onChange(fakeEvent as React.ChangeEvent<HTMLInputElement>);
  }
};
